import {
  ReturnsExceptionMessage,
  returnsExceptionMessages,
} from "../messaging";

export const getReturnsExceptionMessage = (
  browsePageHierarchy: Array<{ categoryId: string }>,
): ReturnsExceptionMessage | undefined => {
  if (!browsePageHierarchy) return;
  const result = returnsExceptionMessages.find((returnsExceptionMessage) => {
    const matchedMessages = returnsExceptionMessage.categories.filter(
      (returnsExceptionMessageCategory) =>
        browsePageHierarchy.find(
          (hierarchyItem) =>
            hierarchyItem.categoryId === returnsExceptionMessageCategory,
        ),
    );
    return matchedMessages.length > 0;
  });
  return result;
};
